import React from 'react';
interface DetailCardProps {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}
export function DetailCard({
  title,
  action,
  children
}: DetailCardProps) {
  return <section className="rounded-2xl border border-navy-100 bg-white shadow-card" data-id="element-247" data-mp="35pi0fy3m94bs">
      <div className="flex items-center justify-between gap-3 border-b border-navy-100 px-5 py-3.5" data-id="element-248" data-mp="39qtpo2ikvnjg">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-navy-600" data-id="element-249" data-mp="2d0jgcvfxns3u">
          {title}
        </h2>
        {action}
      </div>
      <div className="p-5" data-id="element-250" data-mp="2i0fj6rcw9dht">{children}</div>
    </section>;
}
export function FieldList({
  items
}: {
  items: {
    label: string;
    value: React.ReactNode;
  }[];
}) {
  return <dl className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2" data-id="element-251" data-mp="2qshiunf52pr1">
      {items.map(item => <div key={item.label} data-id="element-252" data-mp="1ual40353rcue">
          <dt className="text-xs font-medium uppercase tracking-wide text-navy-500" data-id="element-253" data-mp="1u9jvo6fh14gd">
            {item.label}
          </dt>
          <dd className="mt-1 text-sm font-semibold text-navy-900" data-id="element-254" data-mp="1y9k7djb6r1jq">
            {item.value}
          </dd>
        </div>)}
    </dl>;
}